module.exports = __webpack_public_path__ + "f40d5848cd43f821a9b333c2bb3794eb.pdf";